<template>
  <div v-if="item.id" class="player-wrap">
    <div class="player-top" @click="openSkill">
      <div
        v-if="tagsAdmin"
        class="border"
        :style="tagsAdmin && { borderColor: tagsAdmin.colorBorder }"
      ></div>
      <div class="player-avatar">
        <fps-img :src="`${item.avatarImageUrl}?d=${scale}x${scale}`" />
      </div>
      <div class="tags-wrap">
        <img v-if="tagsAdmin" class="tags-admin" :src="tagsAdmin.src" />
        <div v-if="showTag" :class="showTag.classes">{{ showTag.onlyShowIamge?'':showTag.name }}</div>
      </div>
      <fps-voice
        v-if="item.voiceUrl"
        class="voice-wrap"
        :color="tagsAdmin ? tagsAdmin.colorVoice : '#161F34'"
        :src="item.voiceUrl"
        :init-seconds="item.voiceSecond"
      />
      <div
        v-show="isOnline"
        class="online-status"
        :class="{ 'is-online': isOnline }"
      ></div>
    </div>
    <div class="player-bottom" @click="openSkill">
      <div
        v-if="tagsAdmin"
        class="border"
        :style="tagsAdmin && { borderColor: tagsAdmin.colorBorder }"
      ></div>
      <!-- 自由市集，顯示gameName -->
      <div v-if="item.titleEditable" class="user-info">
        <div class="name" @click.stop>
          <span>{{ item.gameName }}</span>
        </div>
      </div>
      <div v-else class="user-info">
        <div class="name" @click.stop>
          <span>{{ item.nickname }}</span>
        </div>
        <!-- 管理員 -->
        <fps-icon
          v-if="isAdmin"
          class="is-admin"
          type="v-mark"
          size="18"
          color="#FFA24E"
        />
        <!-- 本照認證 -->
        <face-validate
          v-else-if="item.faceSuccess"
          class="face-validate"
          :userUuid="item.userUuid"
          :nickname="item.nickname"
        />
      </div>
      <div class="user-data">
        <fps-star :count="item.starRating" :size="12" />
        <span v-if="item.countComment">（{{ item.countComment }}）</span>
      </div>
      <div v-if="item.salesPrice" class="price-wrap" @click.stop>
        <template v-if="computedPrice">
          <div>
            <span class="prefix">{{ computedPrefix }}</span>
            <span class="prize">{{ computedPrice }}</span
            >幣
          </div>
          <div>
            {{ item.salesPrice }}幣/{{ item.salesUnit | salesUnitTranslate }}
          </div>
        </template>
        <div v-else class="price-normal">
          <span class="prize">{{ item.salesPrice }}</span
          >幣/{{ item.salesUnit | salesUnitTranslate }}
        </div>
      </div>
    </div>
    <SkillDetail v-if="initSkill" v-model="showSkill" :info="item" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SkillDetail from '@/components/SkillDetail';
import FaceValidate from '@/components/FaceValidate';

export default {
  components: {
    SkillDetail,
    FaceValidate
  },
  data() {
    return {
      scale: 600,
      initSkill: false,
      showSkill: false
    };
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    // 僅顯示某個tag
    filterTag: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(['adminUuid']),
    isOnline() {
      return this.$util.isOnline(this.item);
    },
    isAdmin() {
      return this.item.userUuid === this.adminUuid;
    },
    tagsAdmin() {
      const labels = this.item.labelList;
      if (!labels || !labels.length) return '';
      const item = labels.find(item => item.showType === 'AvatarFrame');
      if (!item) return '';
      return {
        src: item.webUrl,
        colorBorder: item.colorBorder,
        colorVoice: item.colorVoice
      };
    },
    showTag() {
      const list = this.$util.computedTags(this.item.labelList);
      if (!list.length) return '';
      const filterId = this.filterTag[0] || list[0].id;
      return (
        list.filter(tag => {
          return tag.id === filterId;
        })[0] || ''
      );
    },
    computedPrice() {
      return this.$util.computedPrice(this.item);
    },
    computedPrefix() {
      const { computedPrice } = this;
      if (!computedPrice) return '';
      const { redBagFreeFlag } = this.item;
      if (redBagFreeFlag) {
        return computedPrice == '1' ? '1幣限購' : '新人特惠';
      } else if (this.item.firstOrderPrivilege) {
        return '首單價';
      } else {
        return '券後價';
      }
    }
  },
  methods: {
    openSkill() {
      const { item } = this;
      let skillId = item.id || item.skillId;
      if (this.$route.name === 'searchList') {
        skillId = null;
      }
      this.$util.openWindow(
        `/player-detail/${item.userUuid || item.uuid}?skillId=${skillId}`
      );
      // if (this.$util.nativeType) {
      //   this.$router.push({
      //     path: `/skill-mobile/${ item.id || item.skillId }/${ item.userUuid || item.uuid }`,
      //   })
      // } else {
      //   this.initSkill = true
      //   this.showSkill = true
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.player-wrap {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.08);
  }
}
.border {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-width: 2px;
  border-style: solid;
}
.player-top {
  position: relative;
  z-index: 1;
  width: 100%;
  height: auto;
  &:hover {
    .player-avatar {
      > * {
        width: 120%;
        height: 120%;
        left: -10%;
        top: -10%;
      }
    }
  }
  .border {
    border-bottom: none;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .player-avatar {
    position: relative;
    z-index: 0;
    overflow: hidden;
    display: block;
    width: 100%;
    height: 0;
    padding-top: 114%;
    background-color: $color-button;
    > * {
      position: absolute;
      overflow: hidden;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all 0.2s;
    }
    /deep/ .fps-img-box {
      width: 101%;
      height: 101%;
      margin: -0.5%;
    }
  }
  .tags-wrap {
    @include flex;
    position: absolute;
    z-index: 2;
    left: 2px;
    top: 2px;
    height: 30px;
    .tags-admin {
      display: block;
      width: auto;
      height: 100%;
    }
    .custom-tag {
      margin-left: 6px;
    }
  }
  .voice-wrap {
    position: absolute;
    z-index: 3;
    left: 8px;
    bottom: 8px;
    width: 80px;
    height: 36px;
  }
  .online-status {
    position: absolute;
    z-index: 4;
    right: 0;
    bottom: -5px;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: #fff;
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: $color-offline;
    }
    &.is-online::after {
      background: $color-green;
    }
  }
}
.player-bottom {
  @include flex(flex-start, flex-start, column);
  position: relative;
  z-index: 0;
  padding: 12px 8px;
  background-color: #fff;
  .border {
    border-top: none;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .user-info {
    @include flex(flex-start);
    position: relative;
    z-index: 2;
    overflow: hidden;
    width: 100%;
    height: 20px;
    .name {
      overflow: hidden;
      @include ellipsis;
      color: $color-gray-1;
      font-size: 14px;
      font-weight: 500;
      cursor: text;
    }
    .is-admin {
      margin-left: 6px;
    }
    .face-validate {
      flex-shrink: 0;
      margin-left: 6px;
    }
  }
  .user-data {
    @include flex;
    position: relative;
    z-index: 2;
    overflow: hidden;
    margin-top: 4px;
    height: 16px;
    color: rgba(99, 109, 134, 0.5);
    font-size: 12px;
  }
  .price-wrap {
    flex-shrink: 0;
    @include flex(flex-start, flex-end);
    position: relative;
    z-index: 2;
    height: 22px;
    margin-top: 12px;
    cursor: text;
    > div {
      @include flex(flex-start, flex-end);
      font-size: 18px;
      &:first-child {
        color: $color-price;
        font-size: 12px;
        height: 24px;
        span {
          &.prefix {
            margin-right: 4px;
          }
          &.prize {
            font-size: 18px;
            font-weight: 600;
            line-height: 18px;
            margin-right: 2px;
          }
        }
      }
      + div {
        margin-left: 8px;
        color: $color-gray-3;
        font-size: 12px;
        text-decoration-line: line-through;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .player-top {
    &:hover {
      .player-avatar {
        > * {
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
